import { formatChecklistDate } from '../FamilyDetail/checklistWords';

// A guardian who has an account gets no note; only the exceptions do.
const OUTCOME_LABELS: Record<string, string | null> = {
  EMAILED_SIGN_IN: null,
  EMAILED_CONNECT: null,
  EMAILED_CHOOSE_PASSWORD: 'Will be asked to create an account',
  NO_EMAIL: 'No email on file — add one on the General tab',
  EMAILS_OFF: 'Family emails turned off',
};

/** A note on one guardian before the invite is sent; null when there is nothing to add. */
export function inviteOutcomeLabel(outcome: string | null | undefined): string | null {
  if (outcome && Object.prototype.hasOwnProperty.call(OUTCOME_LABELS, outcome)) return OUTCOME_LABELS[outcome];
  return 'Not recorded';
}

const RESULT_LABELS: Record<string, string> = {
  INVITED: 'Invited',
  RESENT: 'Reminder sent',
  REFUSED: 'Not sent',
};

/** What happened to one family when the office sent. */
export function inviteResultLabel(status: string | null | undefined): string {
  return (status && RESULT_LABELS[status]) || 'Not recorded';
}

/** Where one guardian stands with the invitation; null means nothing was sent yet. */
export function guardianStatusLabel(status: string | null | undefined, expiresAt?: string | null): string {
  switch (status) {
    case 'SIGNED_IN':
      return 'Has an account';
    case 'INVITATION_SENT':
      return expiresAt ? `Invite sent, expires ${formatChecklistDate(expiresAt)}` : 'Invite sent';
    case 'INVITATION_EXPIRED':
      return 'Invite expired';
    case 'NO_EMAIL':
      return 'No email on file';
    case 'EMAILS_OFF':
      return 'Family emails turned off';
    default:
      return 'Not invited yet';
  }
}
